"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenuButton = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hooks = require("../../../../hooks");
var _MenuItemContent = require("./MenuItemContent");
var _ActiveSubMenuItem = require("./ActiveSubMenuItem");
var _MenuPropTypes = require("./MenuPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const SubMenuButton = _ref => {
  let {
    subMenuItem,
    isSubMenuOpen,
    isHoverTrigger,
    subMenuId,
    hasSubmenu,
    treePosition,
    onMenuButtonClick,
    customTrackingData,
    customTrackingEvents
  } = _ref;
  const {
    url,
    icons,
    isActive,
    isOpen,
    id,
    customCssClass
  } = subMenuItem;
  const subMenuButton = (0, _react.useRef)(null);
  const hasRightIcon = icons && icons.right;
  const hasLeftIcon = icons && icons.left;
  (0, _hooks.useTracking)({
    elementRef: subMenuButton,
    trackingProps: {
      label: subMenuItem.label,
      field: {
        inputType: 'button'
      }
    },
    customTrackingData,
    customTrackingEvents
  });
  if (url && !hasSubmenu) {
    return null;
  }
  if (isActive) {
    return /*#__PURE__*/_react.default.createElement(_ActiveSubMenuItem.ActiveSubMenuItem, {
      subMenuItem: subMenuItem,
      icons: icons,
      isSubMenuOpen: isSubMenuOpen
    });
  }
  const ariaProperties = hasSubmenu ? {
    'aria-expanded': isSubMenuOpen || isOpen,
    'aria-controls': subMenuId
  } : {};
  const itemOverrides = url ? {
    label: 'Open and close submenu',
    hideLabel: true,
    icons: {
      right: icons.right
    }
  } : {};
  const triggerCssClass = "\n    mainMenuTrigger \n    ".concat(url ? 'withLink' : '', " \n    ").concat(hasLeftIcon ? 'hasLeftIcon' : '', " \n    ").concat(hasRightIcon ? 'hasRightIcon' : '', "\n    ").concat(customCssClass || '', "\n  ");
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    ref: subMenuButton
  }, ariaProperties, {
    id: id,
    type: "button",
    className: triggerCssClass,
    onClick: e => onMenuButtonClick(e, subMenuItem, treePosition)
  }), /*#__PURE__*/_react.default.createElement(_MenuItemContent.MenuItemContent, {
    itemDefinition: _objectSpread(_objectSpread({}, subMenuItem), itemOverrides),
    isHoverTrigger: isHoverTrigger,
    isOpen: isSubMenuOpen || subMenuItem.isOpen
  }));
};
exports.SubMenuButton = SubMenuButton;
SubMenuButton.propTypes = {
  subMenuItem: _propTypes.default.shape(_MenuPropTypes.MenuButtonPropTypes),
  isSubMenuOpen: _propTypes.default.bool,
  isHoverTrigger: _propTypes.default.bool,
  subMenuId: _propTypes.default.string,
  hasSubmenu: _propTypes.default.bool,
  treePosition: _propTypes.default.arrayOf(_propTypes.default.number),
  onMenuButtonClick: _propTypes.default.func,
  // eslint-disable-next-line react/forbid-prop-types
  customTrackingData: _propTypes.default.any,
  customTrackingEvents: _propTypes.default.arrayOf(_propTypes.default.string)
};